export default "__VITE_ASSET__5c2592d2__"